import React from 'react';
import { IOperation2, ITaskTreatment, ITreatment2 } from "../../../../util/varibles/interface";
import Icon, { ICON_NAME } from "../../../Icon";
import TaskName from '../../../Operation/Task/TaskName';
import FishUnitInfo from '../FishUnitInfo';
import styles from './style.module.scss';

interface IProps {
    data: IOperation2<ITreatment2>
    unitId: string
}

const UnitInfo: React.FC<IProps> = (props) => {

    const { unitId } = props;
    const { tasks, sub_operations } = props.data.operation;

    const tasksOfUnit = tasks.reduce((rs: ITaskTreatment[], item) => {
        const unit = item.sub_operation || (item.sub_operations ? item.sub_operations[0] : {});
        if (unit.unit_id === unitId)
            return [...rs, item];
        return rs;
    }, []);

    const unit = sub_operations.find(item => item.unit_id === unitId);
    const { note = "" } = unit || {};
    return <div className={styles.info}>
        <div className={styles.tasks}>
            <div data-lev='title'>Task:</div>
            <div data-lev='list'>
                {tasksOfUnit.map((item) => <TaskName
                    key={item.group_id}
                    data={item}
                />)}
            </div>
        </div>
        <FishUnitInfo unit={unit} />
        {note.length > 0 && <div className={styles.note}>
            <Icon className={styles.iconNote} icon={ICON_NAME.NOTE} size='large' />
            <div className={styles.subInfo}>
                <div data-lev='title'>Unit's note:</div>
                <div>{note}</div>
            </div>
        </div>}
    </div>;
};

export default UnitInfo;
